<template>
  <div id="app">
    <el-container style="display: block;">
      <div class="header">
        <div
          style="display: flex;justify-content: space-between;align-items: center;height: 56px;width: 1280px;margin: 0 auto;"
        >
          <!-- <div style="width: 184px;"></div> -->
          <div style="flex: 1; text-align: center;">
            <img
              src="./assets/img/LOGOTOP.png"
              alt="闽江智能数据标注产业基地"
              style="width: 512px; height: 48.39px; display: inline-block; vertical-align: middle;"
            />
          </div>


          <!-- <div style="color: #ffffff; text-align: center; font-size: 35px; font-weight: bold;margin-left: 434px;">闽江智能数据标注产业基地</div> -->
          <!-- <div style="color: #fff;display: flex;">
            <div style="margin-left:20px;cursor: pointer;" @click="golink('https://alidocs.dingtalk.com/notable/share/form/v01pLdn5gkYa5A5Oo83_dv19yqvsgs3oebp3pcjys_1qX0QQ0')">众包注册</div>
            <div style="margin-left:20px;cursor: pointer;" @click="golink('https://alidocs.dingtalk.com/notable/share/form/v01pLdn5gkYa5A5Oo83_dv19yqvsgs3oebp3pcjys_1qX0QQ0')">供应商注册</div>
             <div style="margin-left:20px;">Language</div>
          </div> -->
        </div>
        <div class="line"></div>
        <el-header>
          <div class="logo" @click="go('/')">
            <img
              style="width: 60px; height: 60px;margin-top: 6px;" 
              src="./assets/img/HOME.png"
              alt
            />
            <!-- <div style="color:#fff;font-size: 28px;">福建大数据交易所</div> -->
          </div>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            background-color="#062d4b"
            text-color="#fff"
          >
            <el-menu-item index="1" @click="go('/Pt')">平台</el-menu-item>
            <el-submenu index="2">
              <template slot="title"
                >数据服务</template
              >
              <el-menu-item index="2-2" @click="go('/sjcj')">数据采集服务</el-menu-item>
              <el-menu-item index="2-1" @click="go('/sjbz')">数据标注服务</el-menu-item>
              <el-menu-item index="2-3" @click="go('/dsjsjmx')">大模型数据服务</el-menu-item>
            </el-submenu>
            <el-submenu index="3">
              <template slot="title"
                >数据集</template
              >
              <el-menu-item index="3-1" @click="go('/cpsjj')">数据集总览</el-menu-item>
              <el-menu-item index="3-2" @click="go('/zxsjj')">最新数据集</el-menu-item>
            </el-submenu>
            <el-submenu index="4">
              <template slot="title"
                >应用场景</template
              >
              <el-menu-item index="4-1" @click="go('/znjs')">智能驾驶</el-menu-item>
              <el-menu-item index="4-2" @click="go('/znyl')">智能医疗</el-menu-item>
              <!--el-menu-item index="4-3" @click="go('/qych')">企业出海</el-menu-item>-->
              <el-menu-item index="4-4" @click="go('/hlw')">互联网</el-menu-item>
              <el-menu-item index="4-5" @click="go('/znzd')">智能终端</el-menu-item>
              <el-menu-item index="4-6" @click="go('/dzsw')">电子商务</el-menu-item>
            </el-submenu>



            <!-- <el-submenu index="5">
              <template slot="title">标注基地</template>
              <el-menu-item index="5-1" @click="go('/bzjd')">标注基地</el-menu-item>
              <el-menu-item index="5-2" @click="go('/zbpt')">众包平台</el-menu-item>
            </el-submenu> -->
            <el-menu-item index="5" @click="go('/zbpt')">众包平台</el-menu-item>
            <el-menu-item index="6" @click="go('/xwdt')">新闻动态</el-menu-item>

            <el-menu-item index="7" @click="go('/rcpx')">数据人才培训
            </el-menu-item>
          </el-menu>


          <el-popover
          placement="bottom-end"
          width="250"
          trigger="hover"
          >
          <img
            src="../src/assets/img/minjiangqr.jpg"
          />
          <div style="text-align: center;">微信扫描上方二维码</div>
          <div class="callUs" slot="reference" @click="go('/callMe')">
            联系我们</div>
          <!-- <div class="callUs" slot="reference">联系我们</div> -->
        </el-popover>
        </el-header>
      </div>


      <el-main style="margin-top: 136px;">
        <router-view />
      </el-main>
      <div class="footer" >
        <div style="display: flex;justify-content: space-between;align-items: center;width: 1280px;margin: 0 auto;"> 
          <img style="width: 256px;flex: 0 0 auto;" src="./assets/img/LOGOTOP.png" alt="" />
            <!-- <div style="color:#ffffff;font-size: 36px;font-weight: bold;">闽江智能数据标注产业基地</div>  -->

          <!-- <div style="flex: 1; text-align: center;">
            <div style="color:#ffffff; font-size: 35px; font-weight: bold; display: inline-block;">
                闽江智能数据标注产业基地
            </div>
          </div> -->
          <div style="width: 256px; flex: 0 0 auto;"></div>

          <!-- <div>
            <el-popover
              placement="top-start"
              trigger="hover">
              <img style="width: 150px;" src="./assets/img/qr3.png" alt="" />
              <img slot="reference" style="width: 30px;margin-right: 10px;" src="./assets/img/icon/小红书.png" alt="" />
          </el-popover>
          <el-popover
              placement="top-start"
              trigger="hover">
              <img style="width: 150px;" src="./assets/img/qr.jpg" alt="" />
              <img slot="reference" style="width: 30px;margin-right: 10px;" src="./assets/img/icon/微信.png" alt="" />
              </el-popover>
              <el-popover
              placement="top-start"
              trigger="hover">
              <img style="width: 150px;" src="./assets/img/qr2.png" alt="" />
              <img slot="reference" style="width: 30px;margin-right: 10px;" src="./assets/img/icon/抖音.png" alt="" />
            </el-popover>
          </div> -->
        </div>
        <div class="footer-content">
          <ul class="content-nav">
            
            <li>
              <span @click="go('/Pt')">大模型智能开发平台</span>
            </li>
            <li>
              <span @click="go('/sjcj')">数据采集服务</span>
              <span @click="go('/sjbz')">数据标注服务</span>
              <span @click="go('/dsjsjmx')">大数据模型服务</span>
            </li>
            <li>
              <span @click="go('/znjs')">智能驾驶解决方案</span>
              <span @click="go('/znyl')">智慧医疗解决方案</span>
              <!--span @click="go('/qych')">企业出海解决方案</span>-->
              <span @click="go('/hlw')">互联网解决方案</span>
              <span @click="go('/znzd')">智能终端解决方案</span>
              <span @click="go('/dzsw')">电子商务解决方案</span>
            </li>
            <li>
              <span style="font-weight: bold">友情链接</span>
              <!--div>&nbsp;</div>-->
              <span @click="golink('https://www.nda.gov.cn/sjj/index_pc.html')">国家数据局</span>
              <span @click="golink('https://www.fjbdg.com.cn/')">福建省大数据集团</span>
              <span @click="golink('https://www.fjbdex.com/#/home')">福建大数据交易所</span>
              <span @click="golink('https://sjglj.fuzhou.gov.cn/')">福州市数据管理局</span>
              <span @click="golink('https://www.fzmq.gov.cn/')">闽清县人民政府</span>
              <span @click="golink('https://www.zqlinx.com/')">中启联信科技集团</span>
            </li>
            <li >
              <span>邮箱：market@zqlinx.com</span>
              <span>电话：0591-38205606</span>
              <span>手机：198 9055 5005</span>
              <span
                >联系地址：福建省福州市闽清县闽江大道9号锦绣闽江7栋D148号 闽江智能数据标注产业基地</span
              >
            </li>
          </ul>
          <img src="../src/assets/img/minjiangqr.jpg" alt />
        </div>
        <div @click="goba" style="cursor: pointer;color: #fff;font-size: 14px;border-top: 1px solid #fff;padding-top: 20px;width: 1280px;margin: 20px auto 0;text-align: center;">
          Copyright © 2025 <img style="width: 16px;margin: 0 4px -3px 8px;" src="../src/assets/img/gh.webp" /> 闽ICP备2024080147号-1
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
// import { yiyu } from "https://avatar.gbqr.net/yiyu.js";
export default {
  data() {
    return {
      router: true,
      activeIndex: "",
      isShow: false,
    };
  },
  mounted() {
    // yiyu.init({
    //   name: 'PvYyeRU5DyvOo2wwNjkWIp5cf2hpDlbItZWDJJlCjXpn0nwS7qKLt5PjZ+/JMnMSsR0VhzQn5WRQWqwfb770yVHhlQtPo9L88sAsJj92dDr4PpeA0Cfu6hXr+oxFZNPinebLwGWR4Hpx6YoRt+5XsKDO3Vj/Sf4LIrW3O/4IbGI=',
    //   readLocalResource: false
    // });
  },
  methods: {
    golink(link){
      window.open(link)
    },
    goba(){
      window.open('https://beian.miit.gov.cn/')
    },
    go(path) {
      this.$router.push(path);
      this.defaultActive = "";
      setTimeout(() => {
        switch (path) {
          case "/":
            this.defaultActive = "/";
            break;
          case "/news":
            this.defaultActive = "/news";
            break;
          case "/xscyq":
            this.defaultActive = "/news";
            break;
          case "/xsczj":
            this.defaultActive = "/news";
            break;
          case "/gxAI":
            this.defaultActive = "/news";
            break;
          case "/AIxmt":
            this.defaultActive = "/news";
            break;
          case "/szrsy":
            this.defaultActive = "/news";
            break;
          case "/zhly":
            this.defaultActive = "/news";
            break;
          case "/download":
            this.defaultActive = "/download";
            break;
          case "/sjzcyy":
            this.defaultActive = "/download";
            break;
          case "/product":
            this.defaultActive = "/product";
            break;
          case "/sjkxjf":
            this.defaultActive = "/product";
            break;
        }
      }, 100);
    },
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    },
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.news {
  width: 200px;
  font-size: 18px;
  border-radius: 12px;
  padding: 10px;
  background: rgba(255, 255, 255, 0);
  .news-tab {
    display: flex;
    align-items: center;
    // border-bottom: 1px solid #7caefb;
    text-align: left;
    width: 100%;
    // height: 50px;
    line-height: 50px;
    &:hover {
      color: #7caefb;
      cursor: pointer;
    }
  }
  .news-img {
    width: 20px;
    margin-bottom: -5px;
  }
}
.header {
  z-index: 10000;
  position: fixed;
  top: 0;
  left: 0;
  height: 136px !important;
  width: 100%;
  margin: 0 auto;
  background: #062d4b;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0);
  .line {
    background-image: linear-gradient(
      90deg,
      #000,
      #fff 17.67%,
      #fff 82.17%,
      #000
    );
    width: 1280px;
    margin: 0 auto;
    height: 1px;
    opacity: 0.4;
  }
  .callUs{
    cursor: pointer;
    background-color: #fff;
    padding: 14px 32px;
    height: 20px;
    font-size: 16px;
    margin-top: 15px;
    line-height: 20px;
    color:#125688;
    border-radius: 8px;
  }
}
.el-header {
  height: 80px !important;
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1280px;
  margin: 0 auto;
  // background: rgba(0,0,0, 0.1);
  // backdrop-filter: blur(10px);
  // box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  //background-color: #fff;
  .el-menu-demo {
    height: 79px;
    line-height: 80px;
    // background: rgba(0, 0, 0, 0);
    // border-bottom: 1px solid #f3f3f3 !important;
    // border-bottom: rgba(0, 0, 0, 0) !important;
    .el-menu-item {
      height: 79px;
      line-height: 80px;
      font-size: 16px;
      border-bottom:2px solid #062d4b !important;
    }
    .el-submenu {
      height: 79px;
      line-height: 80px;
      .el-submenu__title {
        height: 79px;
        line-height: 80px;
        font-size: 16px;
        color: #fff !important;
        border-bottom:2px solid #062d4b !important;
      }
    }
    .is-active {
      color:#fff !important;
    }
  }

  .header-console {
    display: flex;
    align-items: center;
    .header-console-login {
      margin-right: 20px;
      font-size: 16px;
      color: #fff;
    }
  }

  .header-console-phone {
    cursor: pointer;
    margin-top: 20px;
    padding: 4px;
    height: 34px;
    // background: #f6f7f9;
    font-family: Barlow-Bold;
    border-radius: 17px;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    color: #7caefb;
    line-height: 26px;
    margin-right: 18px;
  }

  .btn1 {
    width: 98px;
    height: 48px;
    background: linear-gradient(135deg, #7caefb, #526aff);
    border-radius: 4px;
    font-size: 16px;
    color: #fff;
    line-height: 48px;
    text-align: center;
    margin-right: 16px;
    cursor: pointer;
    margin-top: 16px;
  }
  .logo {
    cursor: pointer;
    img {
      width: 100%;
      line-height: 60px;
    }
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  overflow: hidden;
  background-color: #062d4b;
  padding: 50px 45px;
  &-content {
    width: 1280px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        width: 200px;
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
       
        span {
          color: #fff;
          font-size: 16px;
          font-weight: 300;
          padding: 10px 0;
          cursor: pointer;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    height: 30px;
    background: #125688;
    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
</style>
<style lang="scss" >
 .el-menu--popup {
  border-radius: 10px !important;
  padding: 20px 36px !important; /* 调整为需要的padding值 */
  .el-menu-item{
      padding: 10px 20px !important;
      height: auto !important;
      color: #FFF !important;
      border-radius: 5px;
      text-align: center;
      font-size: 16px;
    }
  .el-menu-item:hover{
    background-color: #7cd0ff !important;
    
  }
}

</style>
